const MapProviderType = Object.freeze({
  DEFAULT: "DEFAULT",
  INTERNAL: "INTERNAL",
  GOOGLE: "GOOGLE",
  BING: "BING",
  ARCGIS: "ARCGIS",
  IP2LOCATION: "IP2LOCATION",
  OPENSTREETMAP: "OPENSTREETMAP",
  PRECISELY: "PRECISELY"
});
export default MapProviderType;